const { BRAND_CONFIGS, DEFAULT_BRAND_KEY } = require("./brandConfig");

const HOUSE_HELPER_HOSTNAMES = new Set([
  "house-helper.com",
  "www.house-helper.com",
  "contractors.house-helper.com",
]);

function getDefaultBrand() {
  return BRAND_CONFIGS[DEFAULT_BRAND_KEY];
}

function getBrandByKey(brandKey) {
  const normalized = typeof brandKey === "string" ? brandKey.trim().toLowerCase() : "";
  return BRAND_CONFIGS[normalized] || getDefaultBrand();
}

function normalizeHostname(hostname) {
  if (hostname == null) {
    return "";
  }

  let normalized = String(hostname).trim().toLowerCase();

  if (!normalized) {
    return "";
  }

  if (normalized.startsWith("[") && normalized.includes("]")) {
    return normalized.slice(1, normalized.indexOf("]"));
  }

  normalized = normalized.replace(/\.$/, "");

  const colonIndex = normalized.lastIndexOf(":");
  if (colonIndex > -1 && normalized.indexOf(":") === colonIndex) {
    normalized = normalized.slice(0, colonIndex);
  }

  return normalized.replace(/\.$/, "");
}

function resolveBrandFromHostname(hostname) {
  const normalized = normalizeHostname(hostname);
  return HOUSE_HELPER_HOSTNAMES.has(normalized)
    ? BRAND_CONFIGS["house-helper"]
    : getDefaultBrand();
}

function resolveBrandFromHostHeader(hostHeader) {
  if (!hostHeader) {
    return getDefaultBrand();
  }

  const firstHost = String(hostHeader).split(",")[0].trim();
  return resolveBrandFromHostname(firstHost);
}

function getBrandFromRequest(req, explicitBrandKey) {
  const explicitBrand = explicitBrandKey ? getBrandByKey(explicitBrandKey) : null;
  if (explicitBrandKey && explicitBrand.brandKey) {
    return explicitBrand;
  }

  const trustProxy = Boolean(req?.app?.get?.("trust proxy"));
  const forwardedHost = trustProxy ? req?.headers?.["x-forwarded-host"] : null;
  const host = forwardedHost || req?.headers?.host || req?.hostname || "";

  return resolveBrandFromHostHeader(host);
}

module.exports = {
  getBrandByKey,
  getBrandFromRequest,
  getDefaultBrand,
  normalizeHostname,
  resolveBrandFromHostHeader,
  resolveBrandFromHostname,
};
